module.exports = __webpack_public_path__ + "media/svg/sc-6767d221.svg";